import {externalServices} from '../constants/resourceStrings.constants';
import {getRobloxAuthToken} from './externalServices';
import {addMonths} from 'date-fns';
import {getPageId} from './pageUtils';
import {ContentComponent, PartialContentfulResponse} from '../types';

const {url, redirectParams, contentfulPage, robloxIdName} =
    externalServices.roblox;

const getBoxingBetaAuthCode = (): string | null => {
    const redirectedUrl = new URL(window.location.href);
    return redirectedUrl.searchParams.get('code');
};

export const isBoxingBetaPage = () => contentfulPage === getPageId();

export const isBoxingBetaPageAfterAuth = () =>
    isBoxingBetaPage() && getRobloxId();

export const showActionButton = (pageError?: string) =>
    !pageError && (!isBoxingBetaPage() || getRobloxId());

export const isBoxingBetaAuthNeeded = (): boolean =>
    isBoxingBetaPage() && Boolean(getBoxingBetaAuthCode() && !getRobloxId());

export const handleBoxingBeta = (): void => {
    const parameterNames = [
        'client_id',
        'response_type',
        'scope',
        'state',
        'nonce',
        'redirect_uri'
    ];

    const paramValues = Object.values(redirectParams);
    const robloxUrl = new URL(url);

    parameterNames.forEach((parameterName, index) =>
        robloxUrl.searchParams.append(parameterName, paramValues[index])
    );

    window.location.href = robloxUrl.href;
};

export const getRobloxId = () =>
    document.cookie
        .split(';')
        .find((cookie: string) => cookie.trim().startsWith(robloxIdName))
        ?.replace(/\w+=/, '');

const setRobloxId = (robloxId: string) => {
    document.cookie = `${robloxIdName}=${robloxId}; expires=${addMonths(
        new Date(),
        1
    )}`;
};

export const handleRobloxToken = async (): Promise<string | undefined> => {
    const code = getBoxingBetaAuthCode();

    if (code) {
        const robloxId = await getRobloxAuthToken(code);

        if (robloxId) {
            setRobloxId(robloxId);

            dispatchEvent(
                new CustomEvent('robloxAuthorised', {detail: {robloxId}})
            );
        }
        return robloxId;
    }
};

export const runBoxingBetaAuth = async (
    response: PartialContentfulResponse,
    setPageError: (arg: string) => void
) => {
    if (isBoxingBetaAuthNeeded()) {
        const components = response.items[0].fields.components;
        const boxingBetaPageError = getBoxingBetaError(components);

        try {
            const robloxId = await handleRobloxToken();
            !robloxId && setPageError(boxingBetaPageError);
        } catch (error) {
            console.error(error);
            setPageError(boxingBetaPageError);
        }
    }
};

const getBoxingBetaError = (components: Record<string, any>) => {
    const errors = [
        window.dazn?.resourceStringsData?.Strings['error2_10_000_500_header']
    ];

    components.forEach((contentItem: ContentComponent) => {
        const {errorId} = externalServices.roblox;
        const compField = contentItem?.fields?.entries?.[0]?.fields;

        errorId === compField?.key && errors.unshift(compField?.value);
    });

    return errors[0];
};
